
import KeyPrint from "../../../assets/duotone/KeyPrint.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function KeyPrintIcon({ className, dataTestid = "KeyPrintIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <KeyPrint data-testid={dataTestid} className={classes} {...rest} />
  );
}
